import React, { Fragment } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import PageBannerComponent from "../Components/Common/PageBannerComponent";
import { useGetPlanPartnerQuery } from "../Store/api/CommonApi";

function Partners() {
  const { id, name } = useParams();
  const { data } = useGetPlanPartnerQuery({ plan_id: id });
  const navigate = useNavigate();

  return (
    <Fragment>
      <PageBannerComponent
        title={name ?? "Sponsor Name"}
        //   image={data?.data?.image}
      />
      {/* {data?.data?.content !== "" && (
        <div className="container mt-4">
          <p dangerouslySetInnerHTML={{ __html: data?.data?.content }}></p>
        </div>
      )} */}
      {/* Start service Area */}
      <section className="service-area section-gap" id="service">
        <div className="container">
          <div className="row">
            {data?.data &&
              data?.data.map((company, i) => {
                return (
                  <div className="col-md-2 sponsor_hiring" key={i}>
                    <div className="text-center">
                      <div className="actively_hiring_img">
                        <img
                          src={company?.company_logo}
                          className="img-fluid pic-1"
                          alt={company?.company_name}
                        />
                      </div>

                      <Link
                        // to={`/company-detail/${
                        //   company?.recruiter_id
                        // }/${(
                        //    company?.company_name.toLowerCase()
                        //  ).replaceAll(" ", "-")}`}
                        onClick={() =>
                          navigate(
                            `rise/${company?.company_name.toLowerCase().replaceAll(" ", "-")}`,
                            { state: { id: company?.recruiter_id } },
                          )
                        }
                        className="genric-btn info circle arrow mt-2"
                      >
                        View Jobs
                        <span className="lnr lnr-arrow-right" />
                      </Link>
                    </div>
                  </div>
                );
              })}
            {/* <div className="col-md-2 sponsor_hiring">
              <div className="text-center">
                <div className="actively_hiring_img">
                  <img
                    src={require("../Assets/img/comapny-logos/acuity.jpg")}
                    className="img-fluid pic-1"
                    alt=""
                  />
                </div>
                <a
                  href="company-detail.html"
                  className="genric-btn info circle arrow"
                >
                  View Jobs
                  <span className="lnr lnr-arrow-right" />
                </a>
              </div>
            </div>
            <div className="col-md-2 sponsor_hiring">
              <div className="text-center">
                <div className="actively_hiring_img">
                  <img
                    src={require("../Assets/img/comapny-logos/bcg.jpg")}
                    className="img-fluid pic-1"
                    alt=""
                  />
                </div>
                <a
                  href="company-detail.html"
                  className="genric-btn info circle arrow"
                >
                  View Jobs
                  <span className="lnr lnr-arrow-right" />
                </a>
              </div>
            </div>
            <div className="col-md-2 sponsor_hiring">
              <div className="text-center">
                <div className="actively_hiring_img">
                  <img
                    src={require("../Assets/img/comapny-logos/bcg.jpg")}
                    className="img-fluid pic-1"
                    alt=""
                  />
                </div>

                <a
                  href="company-detail.html"
                  className="genric-btn info circle arrow"
                >
                  View Jobs
                  <span className="lnr lnr-arrow-right" />
                </a>
              </div>
            </div>
            <div className="col-md-2 sponsor_hiring">
              <div className="text-center">
                <div className="actively_hiring_img">
                  <img
                    src={require("../Assets/img/comapny-logos/carelon.jpg")}
                    className="img-fluid pic-1"
                    alt=""
                  />
                </div>

                <a
                  href="company-detail.html"
                  className="genric-btn info circle arrow"
                >
                  View Jobs
                  <span className="lnr lnr-arrow-right" />
                </a>
              </div>
            </div>
            <div className="col-md-2 sponsor_hiring">
              <div className="text-center">
                <div className="actively_hiring_img">
                  <img
                    src={require("../Assets/img/comapny-logos/factset.jpg")}
                    className="img-fluid pic-1"
                    alt=""
                  />
                </div>
                <a
                  href="company-detail.html"
                  className="genric-btn info circle arrow"
                >
                  View Jobs
                  <span className="lnr lnr-arrow-right" />
                </a>
              </div>
            </div>
            <div className="col-md-2 sponsor_hiring">
              <div className="text-center">
                <div className="actively_hiring_img">
                  <img
                    src={require("../Assets/img/comapny-logos/factset.jpg")}
                    className="img-fluid pic-1"
                    alt=""
                  />
                </div>
                <a
                  href="company-detail.html"
                  className="genric-btn info circle arrow"
                >
                  View Jobs
                  <span className="lnr lnr-arrow-right" />
                </a>
              </div>
            </div>
            <div className="col-md-2 sponsor_hiring">
              <div className="text-center">
                <div className="actively_hiring_img">
                  <img
                    src={require("../Assets/img/comapny-logos/acuity.jpg")}
                    className="img-fluid pic-1"
                    alt=""
                  />
                </div>
                <a
                  href="company-detail.html"
                  className="genric-btn info circle arrow"
                >
                  View Jobs
                  <span className="lnr lnr-arrow-right" />
                </a>
              </div>
            </div>
            <div className="col-md-2 sponsor_hiring">
              <div className="text-center">
                <div className="actively_hiring_img">
                  <img
                    src={require("../Assets/img/comapny-logos/adobe.jpg")}
                    className="img-fluid pic-1"
                    alt=""
                  />
                </div>
                <a
                  href="company-detail.html"
                  className="genric-btn info circle arrow"
                >
                  View Jobs
                  <span className="lnr lnr-arrow-right" />
                </a>
              </div>
            </div>
            <div className="col-md-2 sponsor_hiring">
              <div className="text-center">
                <div className="actively_hiring_img">
                  <img
                    src={require("../Assets/img/comapny-logos/bcg.jpg")}
                    className="img-fluid pic-1"
                    alt=""
                  />
                </div>
                <a
                  href="company-detail.html"
                  className="genric-btn info circle arrow"
                >
                  View Jobs
                  <span className="lnr lnr-arrow-right" />
                </a>
              </div>
            </div>
            <div className="col-md-2 sponsor_hiring">
              <div className="text-center">
                <div className="actively_hiring_img">
                  <img
                    src={require("../Assets/img/comapny-logos/carelon.jpg")}
                    className="img-fluid pic-1"
                    alt=""
                  />
                </div>
                <a
                  href="company-detail.html"
                  className="genric-btn info circle arrow"
                >
                  View Jobs
                  <span className="lnr lnr-arrow-right" />
                </a>
              </div>
            </div>
            <div className="col-md-2 sponsor_hiring">
              <div className="text-center">
                <div className="actively_hiring_img">
                  <img
                    src={require("../Assets/img/comapny-logos/factset.jpg")}
                    className="img-fluid pic-1"
                    alt=""
                  />
                </div>
                <a
                  href="company-detail.html"
                  className="genric-btn info circle arrow"
                >
                  View Jobs
                  <span className="lnr lnr-arrow-right" />
                </a>
              </div>
            </div>
            <div className="col-md-2 sponsor_hiring">
              <div className="text-center">
                <div className="actively_hiring_img">
                  <img
                    src={require("../Assets/img/comapny-logos/factset.jpg")}
                    className="img-fluid pic-1"
                    alt=""
                  />
                </div>
                <a
                  href="company-detail.html"
                  className="genric-btn info circle arrow"
                >
                  View Jobs
                  <span className="lnr lnr-arrow-right" />
                </a>
              </div>
            </div> */}
          </div>
        </div>
      </section>
      {/* End service Area */}
    </Fragment>
  );
}

export default Partners;
